export default __webpack_public_path__ + "static/media/playing.421116ec.png";